import { ModelBase } from '../../core/model/model-base';
import { ConnectedCustomProperty } from './connected-custom-property';
import { Competence } from '../../fault-notification/model/competence';
export class ObjectComponentType extends ModelBase {
  constructor(dataContext?: any) {
    super();
    if (dataContext) {
      this.id = dataContext.id;
      this.name = dataContext.name;
      this.lifeSpanYears = dataContext.lifeSpanYears;
      this.competence = dataContext.competence ? new Competence(dataContext.competence) : null;
      this.componentCategory = dataContext.componentCategory;
      this.customProperties = Array.isArray(dataContext.customProperties)
        ? dataContext.customProperties.map(p => new ConnectedCustomProperty(p))
        : [];
      this.standardInBathroom = dataContext.standardInBathroom;
      this.standardInBedroom = dataContext.standardInBedroom;
      this.standardInDressingRoom = dataContext.standardInDressingRoom;
      this.standardInHallway = dataContext.standardInHallway;
      this.standardInKitchen = dataContext.standardInKitchen;
      this.standardInLivingRoom = dataContext.standardInLivingRoom;
      this.standardInToilet = dataContext.standardInToilet;
      this.standardInOther = dataContext.standardInOther;
      this.standardInBalcony = dataContext.standardInBalcony;
    }
  }

  name: string;
  lifeSpanYears: number = null;
  competence: Competence | string = null;
  componentCategory: string;
  customProperties: ConnectedCustomProperty[] = [];
  standardInBathroom = false;
  standardInBedroom = false;
  standardInDressingRoom = false;
  standardInHallway = false;
  standardInKitchen = false;
  standardInLivingRoom = false;
  standardInToilet = false;
  standardInOther = false;
  standardInBalcony = false;

  toJSON() {
    if (this.competence && typeof this.competence !== 'string') this.competence = this.competence.id;

    return this;
  }
}
